import { render, staticRenderFns } from "./BookUpdate.vue?vue&type=template&id=4a4c9997"
import script from "./BookUpdate.vue?vue&type=script&lang=js"
export * from "./BookUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports